import axios, { AxiosResponse, CancelToken } from "axios";
import {
	SubscriptionDetails,
	SubscriptionSummary,
	TwilioSubscriptionAdditionalConfiguration,
	SubscriptionFilters,
	SubscriptionCustomerCompanyKey,
	AmazonConnectSubscriptionAdditionalConfiguration,
} from "../../models/Subscription";
import { GetPageRequest } from "../../models/PageRequest";
import { AddNewSubscriptionRequest } from "../../models/Requests/AddNewSubscriptionRequest";

const getSubscriptionDetails =
	(productId: string, subscriptionId: string) =>
	async (cancelToken?: CancelToken): Promise<AxiosResponse<SubscriptionDetails>> => {
		return await axios.get(`/api/v1/${productId}/subscriptions/${subscriptionId}`, { cancelToken: cancelToken });
	};

const getSubscriptionList =
	(productId: string, getPageRequest: GetPageRequest, filters: SubscriptionFilters) =>
	async (): Promise<AxiosResponse<SubscriptionSummary[]>> => {
		return await axios.post(
			`/api/v1/${productId}/subscriptions/list?companyNameFilter=${filters.companyName}&showExpiredFilter=${filters.showExpired}`,
			getPageRequest,
		);
	};

const getSubscriptionListByCLELoggingType =
	(productId: string, cleLoggingType: string) => async (): Promise<AxiosResponse<SubscriptionSummary[]>> => {
		return await axios.get(`/api/v1/${productId}/subscriptions/list/${cleLoggingType}`);
	};

const updateTwilioSubscriptionConfiguration =
	(productId: string, subscriptionId: string, entry: TwilioSubscriptionAdditionalConfiguration) =>
	async (): Promise<AxiosResponse<void>> => {
		return axios.post(`/api/v1/${productId}/subscriptions/twilio-subscription-config/${subscriptionId}`, entry);
	};

const updateAmazonConnectSubscriptionConfiguration =
	(productId: string, subscriptionId: string, entry: AmazonConnectSubscriptionAdditionalConfiguration) =>
	async (): Promise<AxiosResponse<void>> => {
		return axios.post(`/api/v1/${productId}/subscriptions/amazon-connect-subscription-config/${subscriptionId}`, entry);
	};

const addNewSubscription =
	(productId: string, newSubscription: AddNewSubscriptionRequest) => async (): Promise<AxiosResponse<string>> => {
		return axios.post(`/api/v1/${productId}/subscriptions`, newSubscription);
	};

const getUniqueCustomerKeyCompanyId =
	(productId: string) => async (): Promise<AxiosResponse<SubscriptionCustomerCompanyKey[]>> => {
		return axios.get(`/api/v1/${productId}/subscriptions/uniquecustomerkey`);
	};

export {
	getSubscriptionDetails,
	getSubscriptionList,
	updateTwilioSubscriptionConfiguration,
	updateAmazonConnectSubscriptionConfiguration,
	addNewSubscription,
	getUniqueCustomerKeyCompanyId,
	getSubscriptionListByCLELoggingType,
};
